import { render, staticRenderFns } from "./CalenderPage2.vue?vue&type=template&id=07656b3e"
import script from "./CalenderPage2.vue?vue&type=script&lang=js"
export * from "./CalenderPage2.vue?vue&type=script&lang=js"
import style0 from "./CalenderPage2.vue?vue&type=style&index=0&id=07656b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports